<mat-toolbar color="primary">
    <mat-toolbar-row>
        <span class="app-logo"><img src="assets/asy_round.png" height="40px"></span>
        <span class="app-title">Demon Gate Equipment</span>
        <span class="toolbar-spacer"></span>
        <span class="copyright mat-primary">Demon Gate is copyright &copy; <a href="http://arcanumsyndicate.com/" target="_blank">Arcanum Syndicate</a></span>    
    </mat-toolbar-row>
</mat-toolbar>

<app-equipment-list></app-equipment-list>

<router-outlet></router-outlet>
